"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriorityCell = void 0;
const react_1 = __importDefault(require("react"));
const Flag_1 = __importDefault(require("@mui/icons-material/Flag"));
const priority_cell_styles_1 = require("./priority-cell.styles");
const priority_constants_1 = require("./priority.constants");
const constants_1 = require("../../hooks/table-config/constants");
const localization_1 = require("../../../../../localization");
const PriorityCell = ({ value }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    if (!value)
        return null;
    const colorConfig = priority_constants_1.PRIORITY_COLOR_CONFIG[value];
    const messageKey = constants_1.PRIORITY_TO_LOCALIZATION_MESSAGE_KEY[value];
    if (!colorConfig || !messageKey)
        return null;
    return (react_1.default.createElement(priority_cell_styles_1.StyledPriorityCell, null, react_1.default.createElement(Flag_1.default, { className: "priority-flag-icon", sx: { color: colorConfig.color } }), react_1.default.createElement("span", { className: "priority-label" }, `${value} - ${t({ key: messageKey })}`)));
};
exports.PriorityCell = PriorityCell;
